import { globalEntitlements } from './globalEntitlements';

// Service name constants
const MONTH = 'zb_money_pro_month';
const YEAR = 'zb_money_pro_year';

const MONEY_PRO_ENTITLEMENT = 'money_pro';

/**
 * Generates the configuration for the MoneyPro buy button based on the provided service type.
 *
 * @param {...any} args - Arguments to be passed to the configuration builder.
 * @returns {object} The configuration object for the MoneyPro buy button.
 */
export const getMoneyProBuyButtonConfig = (...args) => {
  const service = args[1]; // Expecting the second argument to be the service (MONTH or YEAR)

  const serviceToButtonText = {
    [MONTH]: 'productPage.zbMoneyPro.buyBox.buttonLabel1',
    [YEAR]: 'productPage.zbMoneyPro.buyBox.buttonLabel2',
  };

  const ctaText = serviceToButtonText[service] || 'productPage.zbMoneyPro.buyBox.buttonLabel1';

  return globalEntitlements({
    ctaText,
  })
    .blockedByRelatedServices([MONEY_PRO_ENTITLEMENT])
    .build()(...args); // Pass all arguments to the builder
};
